import React from 'react';
import {useSelector} from 'react-redux';
import {constant, get, noop} from 'lodash';

import {ClientSupportBonusPlusEligibleUntil} from '/component/partial/report/ClientSupportBonusPlusEligibleUntil';
import CoachesListHeader from '/component/partial/report/CoachesListHeader';
import CoachRank from '/component/partial/report/CoachRank';
import {EligibleCSBNew} from '/component/partial/report/EligibleCSBNew';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {generateOnRecordPress} from '../report.util';

import reportPayload from './reportPayload';

import {useRecordsFiltering} from '/context/RecordsFilter/useRecordsFiltering';
import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface OneToTwoCSBPContentProps {
  loadingData: {
    total?: number;
  };
  showRecordPopover: () => void;
  recordsShowPopover: () => void;
  recordsShowRecord: () => void;
  tierName: string;
}

export const OneToTwoCSBPContent = ({
  loadingData = {},
  showRecordPopover = noop,
  recordsShowPopover = noop,
  recordsShowRecord = noop,
  tierName = '',
}: OneToTwoCSBPContentProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  const {filterParam} = useRecordsFiltering({
    recordsName: reportPayload.reportName,
  });
  const featureFlag = useSelector(variablesFeatureFlag);

  const showCsbPlusInsightsFiltering = shouldReleaseFeature(
    get(featureFlag, 'ff_csb_plus_insights_filtering', ''),
  );
  if (!isReadyToLoad) {
    return null;
  }

  return (
    <ReportDataProvider
      {...reportPayload}
      tierName={tierName}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: CoachesListHeader,
        personRoleComponent: CoachRank,
        isCSBReport: true,
        tierName: tierName,
        personInfoComponent: showCsbPlusInsightsFiltering
          ? EligibleCSBNew
          : ClientSupportBonusPlusEligibleUntil,
        personIsCoach: constant(true),
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params, ...filterParam.params}]}
    />
  );
};
